import type { IconName } from '@aspendental/shared-components-web';
import { useTranslation } from 'next-i18next';

type TileClassification = 'patientInfo' | 'officeDetails' | 'appointmentTime' | 'visitReason';

interface ReviewTileResponse {
	title: string;
	icon: IconName;
	editSectionIndex?: number;
}

export const GenerateReviewTile = (
	classification: TileClassification,
	mottoFlow: boolean,
	reasonForVisitIcon = ''
): ReviewTileResponse => {
	const { t } = useTranslation('appointmentReview');

	const reviewTileData = {
		title: '',
		icon: '',
		editSectionIndex: 0,
	};

	switch (classification) {
		case 'patientInfo':
			reviewTileData.title = t('patientInfo');
			reviewTileData.icon = 'Yourself';
			reviewTileData.editSectionIndex = mottoFlow ? 1 : 0;
			break;
		case 'officeDetails':
			reviewTileData.title = t('officeDetails');
			reviewTileData.icon = 'AspenOffice';
			reviewTileData.editSectionIndex = mottoFlow ? 0 : 1;
			break;
		case 'appointmentTime':
			reviewTileData.title = t('dateTime');
			reviewTileData.icon = 'CalendarDateTime';
			reviewTileData.editSectionIndex = mottoFlow ? 0 : 1;
			break;
		case 'visitReason':
			reviewTileData.title = t('visitReason');
			reviewTileData.icon = 'CheckUp';
			reviewTileData.editSectionIndex = -1; // < no edit for visit reason
			reviewTileData.icon = reasonForVisitIcon;
			break;
		default:
			console.error(t('errorResponse'));
	}

	return reviewTileData as ReviewTileResponse;
};

export const generateReviewTileES = (
	classification: TileClassification,
	mottoFlow: boolean,
	reasonForVisitIcon = ''
): ReviewTileResponse => {
	const reviewTileData = {
		title: '',
		icon: '',
		editSectionIndex: 0,
	};

	switch (classification) {
		case 'patientInfo':
			reviewTileData.title = 'Información del paciente';
			reviewTileData.icon = 'Yourself';
			reviewTileData.editSectionIndex = mottoFlow ? 1 : 0;
			break;
		case 'officeDetails':
			reviewTileData.title = 'Ubicación del consultorio';
			reviewTileData.icon = 'AspenOffice';
			reviewTileData.editSectionIndex = mottoFlow ? 0 : 1;
			break;
		case 'appointmentTime':
			reviewTileData.title = 'Fecha y hora';
			reviewTileData.icon = 'CalendarDateTime';
			reviewTileData.editSectionIndex = mottoFlow ? 0 : 1;
			break;
		case 'visitReason':
			reviewTileData.title = 'Motivo de la visita';
			reviewTileData.icon = 'CheckUp';
			reviewTileData.editSectionIndex = -1; // < no edit for visit reason
			reviewTileData.icon = reasonForVisitIcon;
			break;
		default:
			console.error('generateReviewTile() received invalid classification.');
	}

	return reviewTileData as ReviewTileResponse;
};
